import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CredsModal from '../Vendor/CredsModal';

import PropTypes from 'prop-types';
import ButtonIcon from '../../common/ButtonIcon';
import { FieldGroup } from '../../../libs/formLib';
import { Card, CardBody, FormGroup, Alert, Label, Row, Col, Button, TabContent, TabPane } from 'reactstrap';
import { animateScroll } from 'react-scroll';

import SummaryModal from '../Vendor/Modal';
import BZAPIService from '../../../services/BZAPIService';
import ProductPriority from '../section/ProductPriority';
import DefaultConfigTab from '../section/DefaultConfigTab';
import TabNav from '../section/TabNav';
import TabOne from '../section/TabOne';
import ExecutionStatsTab from '../section/ExecutionStatsTab';
import AITab from '../section/AITab';
import { useScheduling } from '../../../hooks/useScheduling';

// constants
import SETTINGS from '../../../constants/settings';

const ConfigFormLogicMonitor = ({
  vendor,
  vendorLabel,
  isReadOnly,
  vendorId,
  bugsDateBack,
  setBugsDateBack,
  vendorPriorityOptions,
  vendorStatusOptions,
  vendorSupportStatusOptions,
  vendorResolutionOptions,
  snIntegrationCheck,
  services,
  vendors,
  priorityStats,
  snCompanySysIdOptions,
  snCompanySysIdErrors,
  vendorStatuses,
  vendorSupportStatus,
  setVendorStatuses,
  setVendorSupportStatus,
  vendorResolutions,
  setVendorResolutions,
  priorityMaps,
  setPriorityMaps,
  snCompanySysId,
  setSnCompanySysId,
  keywords,
  setKeywords,
  searchFields,
  setSearchFields,
  snPriorityOptions,
  fields,
  handleFieldChange,
  setServices,
  setVendors,
  buildVendorStat,
  setPriorityStats,
  setBugs,
  isConfigured,
  isCve,
  setIsCve,
  syncOnly,
  setSyncOnly,
  loading,
  isServiceActive,
  setIsServiceActive,
  allRequired,
  setAllRequired,
  isUpdated,
  setIsUpdated
}) => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [isValidCredentials, setIsValidCredentials] = useState(false);
  const [isTestingValidCredentials, setIsTestingValidCredentials] = useState(false);
  const [isAddingCredentials, setIsAddingCredentials] = useState(false);

  const [activeTab, setActiveTab] = useState('1');
  const [modalOpen, setModalOpen] = useState(false);
  const [validated, setValidated] = useState(null);
  const [isForceRun, setIsForceRun] = useState(false);

  // Use scheduling hook for state and save function
  const {
    timeUnit,
    setTimeUnit,
    timeValue,
    setTimeValue,
    schedulingMode,
    setSchedulingMode,
    schedules,
    setSchedules,
    nextRun,
    setNextRun,
    saveBugServiceFrequency
  } = useScheduling();

  async function setBugServiceFrequency() {
    await saveBugServiceFrequency(vendorId);
  }
  async function saveServiceAWSSecret() {
    const vendorId = 'logmon';
    const key = 'admin';
    const data = {
      secret: {
        username: fields.username,
        password: fields.password,
        host_url: fields.host_url,
        mfa_secret: fields.mfa_secret
      },
      vendorId: vendorId,
      key: key
    };
    await BZAPIService.createOrUpdateAWSSecret(data);
    // Return the full secret name as expected by the settings
    return { Name: `setting-${vendorId}-${key}` };
  }

  async function testCreds() {
    // Validate all required fields are filled
    if (!fields.username || !fields.password || !fields.host_url || !fields.mfa_secret) {
      setIsSubmitted(true);
      toast.error('Please fill in all required fields.');
      return;
    }

    setIsTestingValidCredentials(true);
    const data = {
      username: fields.username,
      password: fields.password,
      host_url: fields.host_url,
      mfa_secret: fields.mfa_secret
    };
    // if (fields.tenantId.length && fields.appId.length && fields.clientSecret.length) {
    try {
      const result = await BZAPIService.vendorTestCreds(vendorId, data);

      if (result && result.completed) {
        // valid creds
        console.log('results', result);
        setIsAddingCredentials(false);
        setIsValidCredentials(true);
        setIsTestingValidCredentials(false);
        toast.success(`Credentials validated!`);
      } else {
        toast.error('Error validating credentials.');
        setIsAddingCredentials(false);
        setIsValidCredentials(false);
        setIsTestingValidCredentials(false);
      }
    } catch (e) {
      console.log(e);
      toast.error('Credentials failed validation.');
      setIsTestingValidCredentials(false);
      // setIsAddingCredentials(false);
    }
    // }
  }

  async function saveConfig(serviceSecret) {
    // save client config
    const vendorPriorities = priorityMaps.map(mapping => {
      return {
        value: mapping.vendorPriority.value,
        label: mapping.vendorPriority.value,
        snPriority: mapping.snPriority.value
      };
    });

    const data = {
      secretId: serviceSecret.Name,
      bugsDateBack: bugsDateBack,
      snAffectedCIQuery: fields.snAffectedCIQuery,
      filterCVEs: isCve,
      vendorPriorities,
      vendorStatuses,
      vendorSupportStatus,
      vendorResolutions,
      excludedKws: keywords,
      searchFields: searchFields,
      snCompanySysId: snCompanySysId.value ? snCompanySysId.value : fields.snCompanySysId,
      type: SETTINGS.VENDOR
    };

    return BZAPIService.saveSetting(vendorId, syncOnly, data, isForceRun);
  }

  async function handleSave() {
    try {
      setIsSubmitted(true);
      setIsLoading(true);
      // Validate
      // Validate Secrets
      if (!fields.secretId) {
        if (!fields.username || !fields.password || !fields.host_url || !fields.mfa_secret) {
          console.log('missing secret');
          setValidated(false);
          setActiveTab('2');
          setIsLoading(false);
          return;
        }
      }
      if (!bugsDateBack.length || !snCompanySysId) {
        setValidated(false);
        setActiveTab('3');
        setIsLoading(false);
        return;
      }
      if (!priorityMaps.length) {
        // console.log(fields);
        setValidated(false);
        setIsLoading(false);
        setActiveTab('4');
        return;
      }
      if (!vendorSupportStatus.length || !vendorStatuses.length) {
        // console.log(fields);
        setValidated(false);
        setIsLoading(false);
        setActiveTab('4');

        return;
      }
      let serviceSecret;

      if (fields.username && fields.password && fields.host_url && fields.mfa_secret && isValidCredentials) {
        // Updated secrets
        serviceSecret = await saveServiceAWSSecret();
      } else {
        // use existing secrets
        serviceSecret = { Name: fields.secretId };
      }
      // console.log('serviceSecret', serviceSecret);
      if (!serviceSecret || !serviceSecret.Name) {
        setIsLoading(false);
        setValidated(false);
        throw Error('Missing Secret');
      }

      await saveConfig(serviceSecret);
      // set updated secretId
      setBugServiceFrequency();
      fields.secretId = serviceSecret.Name;
      setIsLoading(false);
      setIsSubmitted(false);
      setModalOpen(false);
      setIsForceRun(false);
      setActiveTab('1');
      toast.success(`Settings Saved!`);
    } catch (e) {
      setIsLoading(false);
      toast.error('Failed to save.');
      console.log('e', e);
    }
  }

  function handleValidationError() {
    setModalOpen(!modalOpen);
    animateScroll.scrollTo(70);
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    setIsUpdated(true);
    if (
      bugsDateBack?.length &&
      snCompanySysId?.value &&
      priorityMaps?.length &&
      !priorityMaps.some(mapping => !mapping.snPriority || !mapping.vendorPriority)
    ) {
      setAllRequired(true);
    } else {
      setAllRequired(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    fields,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    bugsDateBack,
    vendorStatuses,
    vendorSupportStatus,
    priorityMaps,
    keywords,
    searchFields,
    snCompanySysId,
    isCve,
    vendorResolutions
  ]);

  return (
    <>
      <TabNav
        vendorId={vendorId}
        aiSupported={vendor?.aiSupported}
        credentials={true}
        activeTab={activeTab}
        snIntegrationCheck={snIntegrationCheck}
        setActiveTab={setActiveTab}
        setIsLoading={setIsLoading}
        isLoading={isLoading}
        setServices={setServices}
        setVendors={setVendors}
        buildVendorStat={buildVendorStat}
        setPriorityStats={setPriorityStats}
        setBugs={setBugs}
        isConfigured={isConfigured}
        loading={loading}
      />

      <TabContent>
        <TabOne
          vendorId={vendorId}
          vendorLabel={vendorLabel}
          credentials={true}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          snIntegrationCheck={snIntegrationCheck}
          services={services}
          vendors={vendors}
          priorityStats={priorityStats}
          isConfigured={isConfigured}
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
          setIsForceRun={setIsForceRun}
          timeUnit={timeUnit}
          setTimeUnit={setTimeUnit}
          timeValue={timeValue}
          setTimeValue={setTimeValue}
          schedulingMode={schedulingMode}
          setSchedulingMode={setSchedulingMode}
          schedules={schedules}
          setSchedules={setSchedules}
          nextRun={nextRun}
          setNextRun={setNextRun}
          loading={loading}
          isServiceActive={isServiceActive}
          setIsServiceActive={setIsServiceActive}
        />
        <DefaultConfigTab
          vendor={vendor}
          activeTab={activeTab}
          vendorLabel={vendorLabel}
          bugsDateBack={bugsDateBack}
          setBugsDateBack={setBugsDateBack}
          isSubmitted={isSubmitted}
          snCompanySysIdErrors={snCompanySysIdErrors}
          snCompanySysIdOptions={snCompanySysIdOptions}
          setSnCompanySysId={setSnCompanySysId}
          snCompanySysId={snCompanySysId}
          fields={fields}
          handleFieldChange={handleFieldChange}
        />
        <form noValidate style={{ minWidth: '100%' }}>
          <TabPane tabId="2">
            {activeTab === '2' && (
              <Card bg={'light'} text={'dak'} className="mb-4">
                <CardBody>
                  <Row form>
                    <Col lg="12">
                      <FormGroup>
                        <Label>
                          Logic Monitor Admin Credentials
                          <span style={{ color: '#bd472a' }}>*</span>
                        </Label>
                        {!isAddingCredentials ? (
                          <>
                            <div>
                              <ButtonIcon
                                onClick={() => setIsAddingCredentials(true)}
                                color="falcon-default"
                                size="sm"
                                icon="plus"
                                iconClassName="fs--2"
                              >
                                Set Credentials
                              </ButtonIcon>

                              {fields.secretId || isValidCredentials ? (
                                <>
                                  {'  '}
                                  <FontAwesomeIcon icon={'check'} style={{ color: 'green', marginLeft: '10px' }} />{' '}
                                  Logic Monitor Credentials Stored
                                </>
                              ) : null}
                            </div>
                          </>
                        ) : (
                          <>
                            <Row>
                              <Col lg="4">
                                <FieldGroup
                                  type="text"
                                  id="username"
                                  onChange={handleFieldChange}
                                  value={fields.username}
                                  label={'Logic Monitor Username'}
                                  showFeedback={!fields.username && isSubmitted}
                                  feedback={'Please specify Logic Monitor Username.'}
                                  placeholder="Enter Logic Monitor Username"
                                  style={{ marginBottom: '10px' }}
                                  required
                                />
                              </Col>
                              <Col lg="4">
                                <FieldGroup
                                  type="password"
                                  id="password"
                                  label={'Logic Monitor Password'}
                                  placeholder="Enter Logic Monitor Password"
                                  onChange={handleFieldChange}
                                  value={fields.password}
                                  showFeedback={!fields.password && isSubmitted}
                                  feedback={'Please specify a Logic Monitor Password.'}
                                  required
                                />
                              </Col>
                              <Col lg="4">
                                <FieldGroup
                                  type="text"
                                  id="host_url"
                                  label={'Logic Monitor Host URL'}
                                  placeholder="Enter Logic Monitor Host URL"
                                  onChange={handleFieldChange}
                                  value={fields.host_url}
                                  showFeedback={!fields.host_url && isSubmitted}
                                  feedback={'Please specify a Logic Monitor Host URL.'}
                                  required
                                />
                              </Col>
                            </Row>
                            <Row>
                              <Col lg="4">
                                <FieldGroup
                                  type="text"
                                  id="mfa_secret"
                                  label={'MFA Code / Token'}
                                  placeholder="Enter MFA code if required"
                                  onChange={handleFieldChange}
                                  value={fields.mfa_secret}
                                  showFeedback={!fields.mfa_secret && isSubmitted}
                                  feedback={'Please specify MFA code.'}
                                  required
                                />
                              </Col>
                            </Row>

                            <CredsModal
                              isTestingValidCredentials={isTestingValidCredentials}
                              setIsTestingCredentials={setIsTestingValidCredentials}
                              fields={fields}
                              testCreds={testCreds}
                              vendorId={vendorId}
                            />
                            <ButtonIcon
                              onClick={() => setIsAddingCredentials(false)}
                              color="falcon-default"
                              size="sm"
                              icon="times"
                              iconclassname="fs--2"
                              style={{ marginRight: '10px' }}
                            >
                              Cancel
                            </ButtonIcon>
                          </>
                        )}
                        {!fields.secretId && !isValidCredentials && isSubmitted && (
                          <Row className="mt-3">
                            <Col>
                              <Alert color="danger">Please specify credentials.</Alert>
                            </Col>
                          </Row>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            )}
          </TabPane>
          <TabPane tabId="4">
            {activeTab === '4' && (
              <ProductPriority
                title="Default Bug Configuration"
                vendorPriorityOptions={vendorPriorityOptions}
                vendorStatusOptions={vendorStatusOptions}
                vendorSupportStatusOptions={vendorSupportStatusOptions}
                vendorResolutionOptions={vendorResolutionOptions}
                setVendorStatuses={setVendorStatuses}
                setVendorSupportStatus={setVendorSupportStatus}
                vendorStatuses={vendorStatuses}
                vendorSupportStatus={vendorSupportStatus}
                isSubmitted={isSubmitted}
                vendorId={vendorId}
                priorityMaps={priorityMaps}
                setVendorResolutions={setVendorResolutions}
                vendorResolutions={vendorResolutions}
                setPriorityMaps={setPriorityMaps}
                snPriorityOptions={snPriorityOptions}
                keywords={keywords}
                setKeywords={setKeywords}
                searchFields={searchFields}
                setSearchFields={setSearchFields}
                isCve={isCve}
                setIsCve={setIsCve}
              />
            )}
          </TabPane>
          <TabPane tabId="8">{activeTab === '8' && <AITab vendorId={vendorId} isReadOnly={isReadOnly} />}</TabPane>
          <TabPane tabId="6">{activeTab === '6' && <ExecutionStatsTab vendorId={vendorId} />}</TabPane>

          <Row className={`${activeTab === '1' ? 'd-none' : ''} flex-between-center`}>
            <Col xs="auto">
              <Button
                block
                color="falcon-danger"
                onClick={() => {
                  console.log(`/vendors/${vendorId}/configuration`);
                  navigate(-1);
                }}
              >
                Cancel
              </Button>
            </Col>
            <Col xs="auto">
              <SummaryModal
                modalOpen={modalOpen}
                isReadOnly={isReadOnly}
                setModalOpen={setModalOpen}
                handleSave={handleSave}
                isLoading={isLoading}
                vendorLabel={vendorLabel?.replace('Systems', 'Networks')}
                vendorId={vendorId}
                validated={validated}
                setValidated={setValidated}
                syncOnly={syncOnly}
                setSyncOnly={setSyncOnly}
                handleValidationError={handleValidationError}
                allRequired={allRequired}
                isUpdated={isUpdated}
              />
            </Col>
          </Row>
        </form>
      </TabContent>
    </>
  );
};
ConfigFormLogicMonitor.propTypes = {
  vendor: PropTypes.object,
  isReadOnly: PropTypes.bool,
  settings: PropTypes.object,
  vendorLabel: PropTypes.string,
  vendorId: PropTypes.string,
  vendorPriorityOptions: PropTypes.array,
  vendorStatusOptions: PropTypes.array,
  vendorSupportStatusOptions: PropTypes.array,
  vendorResolutionOptions: PropTypes.array,
  snCompanySysIdOptions: PropTypes.object,
  snCompanySysId: PropTypes.object,
  snIntegrationCheck: PropTypes.bool,
  services: PropTypes.array,
  vendors: PropTypes.array,
  priorityStats: PropTypes.object,
  snCompanySysIdErrors: PropTypes.bool,
  vendorEventScopes: PropTypes.array,
  setVendorEventScopes: PropTypes.func,
  vendorResolutions: PropTypes.array,
  setVendorResolutions: PropTypes.func,
  setVendorStatuses: PropTypes.func,
  setVendorSupportStatus: PropTypes.func,
  vendorStatuses: PropTypes.array,
  vendorSupportStatus: PropTypes.array,
  fields: PropTypes.object,
  handleFieldChange: PropTypes.func,
  priorityMaps: PropTypes.array,
  setPriorityMaps: PropTypes.func,
  snPriorityOptions: PropTypes.array,
  keywords: PropTypes.array,
  setKeywords: PropTypes.func,
  searchFields: PropTypes.array,
  setSearchFields: PropTypes.func,
  setSnCompanySysId: PropTypes.func,
  bugsDateBack: PropTypes.string,
  setBugsDateBack: PropTypes.func,
  setServices: PropTypes.func,
  setVendors: PropTypes.func,
  buildVendorStat: PropTypes.func,
  setBugs: PropTypes.func,
  setPriorityStats: PropTypes.func,
  isConfigured: PropTypes.bool,
  isCve: PropTypes.bool,
  setIsCve: PropTypes.func,
  syncOnly: PropTypes.bool,
  setSyncOnly: PropTypes.func,
  loading: PropTypes.bool,
  setIsServiceActive: PropTypes.func,
  isServiceActive: PropTypes.number,
  allRequired: PropTypes.bool,
  isUpdated: PropTypes.bool,
  setAllRequired: PropTypes.func,
  setIsUpdated: PropTypes.func
};
export default ConfigFormLogicMonitor;
